<template>
    <div>
        <!--    页面标题 start -->
        <div v-web-title :data-title="$t('message.bookRoom.title')"></div>
        <!--    页面标题 end -->

        <Row class-name="page-content" type="flex" justify="center">
            <!--            订房信息填写区域 start -->
            <i-col :xs="24" :md="12" :lg="7" class-name="left-block">
                <div v-if="!isLogin">
                    <div class="login-desc">
                        <Icon type="md-information-circle" size="15" color="#b2b2b2"/>
                        <div v-if="lang === 'en'">
                            <span class="login-register-text" @click="showLoginModal">{{$t('message.bookRoom.loginDesc.loginOrRegister')}}</span>
                            {{$t('message.bookRoom.loginDesc.loginDesc1')}}
                            <span class="bold-font">{{$t('message.bookRoom.loginDesc.loginDesc2')}}</span>
                        </div>
                        <div v-else>
                            <span class="login-register-text" @click="showLoginModal">{{$t('message.bookRoom.loginDesc.loginOrRegister')}},</span>
                            <span class="cn-bold-font">{{$t('message.bookRoom.loginDesc.loginDesc1')}}</span>
                            {{$t('message.bookRoom.loginDesc.loginDesc2')}}
                        </div>
                    </div>

                    <div class="line line-wrapper"></div>
                </div>
                <div class="guest-info-block">
                    <div class="guest-title-wrapper">
                        <span class="guest-title">{{$t('message.bookRoom.mainGuest')}}</span>
                        <Poptip word-wrap trigger="hover" placement="bottom">
                            <Icon type="md-information-circle" size="20" color="#b2b2b2"/>
                            <div class="guest-poptip" slot="content">
                                <div class="guest-poptip-title">{{$t('message.bookRoom.guestPoptipTitle')}}</div>
                                <div class="guest-poptip-content">
                                    <div>{{$t('message.bookRoom.guestPoptipContent1')}}</div>
                                    <div>{{$t('message.bookRoom.guestPoptipContent2')}}</div>
                                </div>
                            </div>
                        </Poptip>
                    </div>
                    <div class="guest-name-desc">{{$t('message.bookRoom.guestNameDesc')}}</div>
                    <div>
                        <div class="fullName-block">
                            <label class="fullName" for="firstName">{{$t('message.bookRoom.firstName')}}</label>
                            <i-input ref="firstName" class="fullName-input" size="large" type="text"
                                   name="firstName"
                                   id="firstName"
                                   :placeholder="$t('message.bookRoom.firstNamePlaceholder')"
                                   v-model="firstName"
                                   clearable>
                                <Icon slot="prefix" type="ios-contact" />
                                <Icon v-show="isLogin" slot="suffix" type="md-add-circle"
                                      class="addGuest" @click="showGuestList"/>
                            </i-input>
                            <div class="input-validate">{{firstNameValidate}}</div>
                        </div>
                        <div class="fullName-block">
                            <label class="fullName" for="LastName">{{$t('message.bookRoom.lastName')}}</label>
                            <i-input class="fullName-input" size="large" type="text" name="lastName"
                                   id="lastName"
                                   :placeholder="$t('message.bookRoom.lastNamePlaceholder')"
                                   v-model="lastName"
                                   clearable>
                                <Icon slot="prefix" type="ios-contact" />
                                <Icon v-show="isLogin" slot="suffix" type="md-add-circle"
                                      class="addGuest" @click="showGuestList" />
                            </i-input>
                            <div class="input-validate">{{lastNameValidate}}</div>
                        </div>
                        <div class="fullName-block">
                            <label class="fullName" for="number">{{$t('message.bookRoom.guestsNumber')}}</label>
                            <InputNumber class="fullName-input" size="large" :max=maxNum :min=1 name="number" id="number"
                                         placeholder="1"
                                         v-model="guestNum"
                                         @on-change="changeNum"
                            />
                        </div>
                    </div>
                    <div class="booking-contact-block">
                        <div class="title">{{$t('message.bookRoom.bookingContact')}}</div>
                        <div class="input-block">
                            <label class="label-text" for="email">{{$t('message.bookRoom.email')}}</label>
                            <Input class="email-input" size="large" type="text" name="email" id="email"
                                   :placeholder="$t('message.bookRoom.emailPlaceholder')"
                                   v-model="email"
                                   prefix="ios-mail"
                                   clearable
                            />
                            <div class="input-validate">{{emailValidate}}</div>
                            <div class="input-desc">{{$t('message.bookRoom.emailDesc')}}</div>
                        </div>
                        <div v-if="!isLogin" class="register-block">
                            <Checkbox class="register-suggest" v-model="isShowPassword">
                                {{$t('message.bookRoom.registerCheckbox')}}
                                <Icon type="md-thumbs-up" size="16" color="#0d6fb8"/>
                            </Checkbox>
                            <div class="password-block"
                                 :class="{'show-password': isShowPassword, 'hide-password': !isShowPassword}">
                                <label class="label-text" for="password">{{$t('message.bookRoom.createPassword')}}</label>
                                <Input :placeholder="$t('message.bookRoom.passwordPlaceholder')"
                                       ref="password"
                                       password type="password"
                                       v-model="password"
                                       prefix="md-lock"
                                       name="password"
                                       id="password"/>
                                <div class="input-validate">{{passwordValidate}}</div>
                                <label class="label-text" for="confirm_password">{{$t('message.bookRoom.confirmPassword')}}</label>
                                <Input :placeholder="$t('message.bookRoom.confirmPasswordPlaceholder')"
                                       password type="password"
                                       v-model="confirmPassword"
                                       prefix="md-lock"
                                       name="confirm_password"
                                       id="confirm_password"/>
                                <div class="input-validate">{{confirmPasswordValidate}}</div>
                            </div>
                        </div>
                        <div class="input-block">
                            <label class="label-text">{{$t('message.bookRoom.phoneNumber')}}</label>
                            <div class="input-group">
                                <i-select class="country-code"
                                          v-model="regionName"
                                          id="regionName"
                                          :placeholder="$t('message.bookRoom.regionPlaceholder')"
                                          @on-change="changeRegionIndex"
                                          filterable>
                                    <Icon type="md-globe" size="18" color="grey" slot="prefix"></Icon>
                                    <i-option v-for="(region, index) in regionData"
                                              :value="region"
                                              :key="index">{{region}}
                                    </i-option>
                                </i-select>
                                <div class="input-validate">{{regionValidate}}</div>
                                <i-input class="phone-number" type="number"
                                         v-model="phone"
                                         id="phone"
                                         :placeholder="$t('message.bookRoom.phonePlaceholder')"
                                         clearable>
                                    <i-select slot="prepend" style="width: 80px"
                                              v-model="regionCodeValue" @on-change="changeRegionCodeIndex">
                                        <i-option v-for="(regionCode, index) in regionCodes"
                                                  :value="regionCode.label"
                                                  :key="index"
                                                  :label="regionCode.label">{{regionCode.value}}
                                        </i-option>
                                    </i-select>
                                </i-input>
                                <div class="input-validate">{{phoneValidate}}</div>
                            </div>

                        </div>
                    </div>

                    <div class="booking-contact-block">
                        <div class="title">{{$t('message.bookRoom.couponWay')}}</div>
                        <div class="input-block">
                            <label class="label-text">{{$t('message.bookRoom.chooseCoupon')}}</label>
                            <div class="choose-coupon" @click="showChooseCoupon">
                                {{couponPlaceholder}}
                                <Icon type="ios-arrow-forward" size="20" color="#b2b2b2" />
                            </div>
                        </div>
                    </div>

                </div>

                <div class="book-policy">
                    {{$t('message.bookRoom.privacyPolicy1')}}
                    <span class="policy">{{$t('message.bookRoom.privacyPolicy2')}}</span>
                    {{$t('message.bookRoom.privacyPolicy3')}}
                    <span class="policy">{{$t('message.bookRoom.privacyPolicy4')}}</span>
                </div>

                <Button class="book-button" type="primary" size="large" @click="submitOrder">
                    <span class="book-button-text">{{$t('message.bookRoom.bookButton')}}</span>
                    <Icon type="md-lock" size="14" color="white"/>
                </Button>

            </i-col>
            <!--            订房信息填写区域 end -->

            <!--            房间信息展示区域 start -->
            <i-col :xs="24" :md="12" :lg="7"  class-name="right-block">
                <div class="room-info-block">
                    <div class="room-name">{{roomData.room_name}}</div>
                    <div class="room-desc">
                        <span>{{roomData.introduce}}</span>
                    </div>
                    <div class="room-desc">
                        <Icon type="md-pin" size="16" color="grey"/>
                        <span>{{motelInfo['address']}}</span>
                    </div>
                    <div class="line line-wrapper"></div>
                    <div class="checkin-block">
                        <div class="order-info">
                            <div class="name">{{$t('message.bookRoom.checkinDate')}}</div>
                            <div class="value">{{checkinDate}}</div>
                        </div>
                        <div class="order-info">
                            <div class="name">{{$t('message.bookRoom.checkoutDate')}}</div>
                            <div class="value">{{checkoutDate}}</div>
                        </div>
                    </div>
                    <div class="checkin-block">
                        <div class="order-info">
                            <div class="name">{{$t('message.bookRoom.guests')}}</div>
                            <div class="value">{{guestNumStr}}</div>
                        </div>
                        <div class="order-info">
                            <div class="name">{{$t('message.bookRoom.stay')}}</div>
                            <div class="value">{{totalNights}}</div>
                        </div>
                    </div>
                    <div class="line line-wrapper"></div>
                    <div class="room-img-wrapper">
                        <img :src="roomData.src" alt="">
                    </div>
                    <div class="room-info">
                        <div v-if="roomData.label" class="room-info-item">
                            <m-icons class="room-info-icon" type="wheelchair" size="14" color="#00C957" />
                            <div class="good">{{roomData.label}}</div>
                        </div>
                        <div class="room-info-item">
                            <Icon type="md-resize" size="12" color="grey"/>
                            <div>12 m<sup>2</sup></div>
                        </div>
                        <div class="room-info-item">
                            <Icon type="ios-alarm" size="12" color="orange"/>
                            <div class="warning">{{$t('message.bookRoom.confirmCheckin')}}</div>
                        </div>
                        <div class="room-info-item">
                            <Icon type="ios-cafe" size="12" color="crimson"/>
                            <div class="danger">{{$t('message.bookRoom.mealNotIncluded')}}</div>
                        </div>
                        <div class="room-info-item">
                            <Icon type="md-man" size="12" color="grey"/>
                            <div>{{$t('message.bookRoom.maxGuests1')}} {{roomData.max}} {{$t('message.bookRoom.maxGuests2')}}</div>
                        </div>
                        <div class="room-info-item">
                            <Icon type="logo-usd" size="12" color="grey"/>
                            <div>{{$t('message.bookRoom.payUpfront')}}</div>
                        </div>
                        <div v-if="isFreeRefundable" class="room-info-item">
                            <Icon type="md-checkmark-circle" size="12" color="#00C957"/>
                            <div class="normal">{{$t('message.bookRoom.cancellation1')}} {{freeRefundableStr}} {{$t('message.bookRoom.cancellation2')}}</div>
                        </div>
                        <div v-else class="room-info-item">
                            <Icon type="md-close-circle" size="12" color="grey"/>
                            <div>{{$t('message.bookRoom.noRefundable')}}</div>
                        </div>
                    </div>
                </div>

                <div class="price-block">
                    <div v-for="(dateItem, index) in roomData.date_data"
                         class="date-price-wrapper" :key="index">
                        <div class="date">{{dateItem.date}}</div>
                        <div class="price">{{getLocalCurrencySymbol()}} {{dateItem.money1}}</div>
                    </div>

<!--                    <div class="date-price-wrapper">-->
<!--                        <div class="date">{{$t('message.bookRoom.taxesAndFees')}}</div>-->
<!--                        <div class="price">$10.68</div>-->
<!--                    </div>-->
<!--                    <div class="tax-block">-->
<!--                        <div class="tax">{{$t('message.bookRoom.tax1')}}</div>-->
<!--                        <div class="price">$10.68</div>-->
<!--                    </div>-->

                    <div class="line line-wrapper"></div>
                    <div class="total-wrapper">
                        <div class="total">{{$t('message.bookRoom.total')}}</div>
                        <div class="price">{{getLocalCurrencySymbol()}} {{roomData.total1}}</div>
                    </div>
                </div>

                <div class="cancel-policy-block">
                    <div v-if="isFreeRefundable">
                        <div class="title-wrapper">
                            <Icon type="md-checkmark" size="18" color="#00C957"/>
                            <span>{{$t('message.bookRoom.freeCancellation')}}</span>
                        </div>
                        <div class="cancel-policy">
                            {{$t('message.bookRoom.freeCancellationDesc1')}} {{freeRefundableStr}} {{$t('message.bookRoom.freeCancellationDesc2')}}
                        </div>
                    </div>
                    <div v-else>
                        <div class="title-wrapper">
                            <Icon type="md-close-circle" size="18" color="grey"/>
                            <span class="grey-color">{{$t('message.bookRoom.noRefundable')}}</span>
                        </div>
                    </div>
                    <div class="title-wrapper">
                        <Icon type="md-time" size="18" color="#00C957"/>
                        <span>{{$t('message.bookRoom.instantConfirmation')}}</span>
                    </div>
                </div>

                <div class="mobile-book-policy">
                    {{$t('message.bookRoom.privacyPolicy1')}}
                    <span class="policy">{{$t('message.bookRoom.privacyPolicy2')}}</span>
                    {{$t('message.bookRoom.privacyPolicy3')}}
                    <span class="policy">{{$t('message.bookRoom.privacyPolicy4')}}</span>
                </div>

                <Button class="mobile-book-button" type="primary" size="large" @click="submitOrder">
                    <span class="book-button-text">{{$t('message.bookRoom.bookButton')}}</span>
                    <Icon type="md-lock" size="14" color="white"/>
                </Button>

            </i-col>
            <!--            房间信息展示区域 end -->
        </Row>

        <!--            登录对话框 start -->
        <LoginModal :is-show-login="isShowLoginModal" :email="email" :handler="reloadData"
                    @updateShowLoginModalStatus="setIsShowLoginModal"/>
        <!--            登录对话框 end -->

<!--        希望用户注册提示 start -->
        <Modal v-model="isShowHopeRegister" :mask-closable="false"
               @on-ok="showRegister" @on-cancel="anonymousOrder">
            <p slot="header" class="modal-title">{{$t('message.bookRoom.hopeRegisterModalTitle')}}</p>
            <p class="modal-content">{{$t('message.bookRoom.hopeRegisterModalContent1')}}{{unRegisteredIntegral}}{{$t('message.bookRoom.hopeRegisterModalContent2')}}</p>
        </Modal>
<!--        希望用户注册提示 end -->

<!--        选择优惠券对话框 start -->
        <Modal v-model="isShowChooseCoupon" fullscreen :mask-closable="false" @on-cancel="noCoupon">
            <p slot="header">选择优惠券</p>
            <div>
                <Coupon :is-modal="true"
                        :handle-use-coupon="useCoupon"
                        :room-type-prop="roomData.room_type"
                        @selectedCoupon="selectedCoupon" />
            </div>
            <div slot="footer" class="choose-coupon-button-block">
                <Button type="primary" class="choose-coupon-button" @click="noCoupon"><span class="button-text">关闭</span></Button>
            </div>
        </Modal>
<!--        选择优惠券对话框 end -->

<!--        选择常住人对话框 start -->
        <Modal v-model="isShowChooseGuest" :title="$t('message.bookRoom.chooseGuestTitle')" :mask-closable="false"
               @on-ok="useSelectedGuest" @on-cancel="cancelSelectedGuest">
            <div class="guest-list">

                <div v-for="(guest, index) in guestList" :key="guest.id"
                     :class="{'selected-guest': selectedGuestIndex === index}"
                     class="guest-block" @click="chooseGuest(index)">
                    <Icon type="md-person" size="20" color="#b2b2b2"/>
                    <div class="name">{{getFullName(guest)}}</div>
                    <Icon v-if="selectedGuestIndex === index" class="check-icon" type="md-checkmark-circle" size="18" color="#00C957" />
                    <Icon v-else class="check-icon" type="md-checkmark-circle" size="18" color="#b2b2b2" />
                </div>

            </div>
        </Modal>
<!--        选择常住人对话框 end -->

    </div>
</template>

<script>
  import moment from 'moment';
  import mIcons from '@/components/m-icons/m-icons.vue';
  import {
    getLocalCurrencySymbol,
    getLocalCurrency,
    getLocalLang,
    getRegionCodes,
    getRegions,
    urlRequest,
    getMultiLangRegion, isEnglishNameValidate, empty, emailValidate, gotoPage
  } from "../../common/common";
  import LoginModal from "../../components/LoginModal/LoginModal.vue";
  import {mapMutations, mapState} from "vuex";
  import Coupon from "../../components/coupon/Coupon";

  export default {
    // 订单提交页面
    name: "BookRoom",

    data() {
      return {
        // 入住日期
        checkinDate: '',
        // 离店日期
        checkoutDate: '',
        // 最大入住人数
        maxNum: 0,
        // 入住人数
        guestNum: 1,
        // 免费退房日期
        freeCheckoutDate: {},
        // 是否展示登录对话框
        isShowLoginModal: false,
        // 是否展示希望用户注册对话框
        isShowHopeRegister: false,
        // 是否展示选择优惠券对话框
        isShowChooseCoupon: false,
        // 是否展示常住人选择对话框
        isShowChooseGuest: false,
        // 选中的常住人index
        selectedGuestIndex: -1,
        // 常住人数据
        guestList: [],
        // 是否允许已有积分账号匿名下单
        allowAnonymousOrder: false,
        // 未注册账号已有的积分
        unRegisteredIntegral: 0,
        // 语言
        lang: '',
        // 房间列表数据
        roomList: [],
        // 房间Id
        roomId: 0,
        // 房间数据
        roomData: [],
        // 酒店信息
        motelInfo: {},
        // 姓
        lastName: '',
        // 名
        firstName: '',
        // 邮箱
        email: '',
        // 密码
        password: '',
        // 确认密码
        confirmPassword: '',
        // 手机号码
        phone: '',
        // 是否展示注册密码框
        isShowPassword: false,
        // 国家地区数据
        regionData: [],
        // 国家地区电话编码数据
        regionCodes: [],
        // 选中的国家地区index
        regionIndex: 0,
        // 选中的国家地区编码index
        regionCodeIndex: 0,
        // 选中的国家地区
        regionName: '',
        // 选中的国家地区编码
        regionCodeValue: '',
        // 获取本地货币符号
        getLocalCurrencySymbol: getLocalCurrencySymbol,
        // 名字校验
        firstNameValidate: '',
        // 姓氏校验
        lastNameValidate: '',
        // 邮箱校验
        emailValidate: '',
        // 密码校验
        passwordValidate: '',
        // 确认密码校验
        confirmPasswordValidate: '',
        // 地区校验
        regionValidate: '',
        // 电话校验
        phoneValidate: '',
        // 优惠券ID
        couponId: 0,
        // 优惠券占位文本
        couponPlaceholder: '',

      }
    },

    created() {

      // 初始化所选优惠券ID和优惠券占位字符文本
      if (empty(localStorage.getItem('coupon'))) {
        this.couponId = 0;
        this.couponPlaceholder = this.$t('message.bookRoom.couponPlaceholder');
      } else {
        let coupon = JSON.parse(localStorage.getItem('coupon'));
        this.couponId = coupon.mc_id;
        this.couponPlaceholder = coupon.name;
      }

      // 获取用户邮箱信息
      this.email = this.getEmail();

      // 如果缓存有订单客人数据，则初始化之
      const bookInfo = JSON.parse(localStorage.getItem('bookInfo'));
      if (!empty(bookInfo)) {
        this.firstName = bookInfo.firstName;
        this.lastName = bookInfo.lastName;
        this.guestNum = bookInfo.guestNum;
        this.regionName = bookInfo.regionName;
        this.regionCodeValue = bookInfo.regionCodeValue;
        this.phone = bookInfo.phone;
      }
      // 使用完缓存的订单客人数据就清除掉
      localStorage.removeItem('bookInfo');

      // 从缓存获取入住和离店日期
      this.checkinDate = localStorage.getItem('checkinDate');
      this.checkoutDate = localStorage.getItem('checkoutDate');
      // 从缓存获取语言
      this.lang = getLocalLang();
      // 前页传来的参数
      console.log('params: ', this.$route.query);
      this.roomId = this.$route.query.roomId;

      // 从缓存获取酒店信息
      this.motelInfo = JSON.parse(localStorage.getItem('motelInfo'));
      console.log('motel address: ', this.motelInfo.name, this.motelInfo)

      // 获取国家地区数据
      this.getRegionData();
      // 获取国家地区电话编码数据
      this.getRegionCodes();
      // 获取房间数据
      this.loadData();
      // 计算免费退房时间
      this.getFreeCheckoutDate();

    },

    methods: {

      ...mapMutations([
        // 修改登录状态
        'setLoginStatus',
        // 保存用户信息
        'setUserInfo',
      ]),

      // 展示常住人列表
      showGuestList() {
        this.isShowChooseGuest = true;
        // 请求常住人数据
        urlRequest({
          url: this.api.getGuestList,
          method: 'POST'
        }).then(res => {
          this.guestList = res.data.msg.sort((a, b) => {
            return b.id - a.id;
          });
        });
      },

      // 选择常住人
      chooseGuest(index) {
        this.selectedGuestIndex = index;
      },

      // 使用选中的常住人，把常住人名字写入当前订单
      useSelectedGuest() {
        this.firstName = this.guestList[this.selectedGuestIndex].name;
        this.lastName = this.guestList[this.selectedGuestIndex].surname;
        this.selectedGuestIndex = -1;
      },

      // 取消选中的常住人
      cancelSelectedGuest() {
        this.selectedGuestIndex = -1;
      },

      // 获取全名
      getFullName(guest) {
        return `${guest.name} ${guest.surname}`;
      },

      // 登录后重新加载数据
      reloadData() {
        this.loadData();
      },

      // 关闭选择优惠券对话框
      noCoupon() {
        this.couponId = 0;
        this.isShowChooseCoupon = false;
        this.couponPlaceholder = this.$t('message.bookRoom.couponPlaceholder');
        this.loadData();
      },

      // 对话框传回选择的优惠券
      selectedCoupon(coupon) {
        console.log('couponId: ', coupon.mc_id);
        this.couponId = coupon.mc_id;
        this.couponPlaceholder = coupon.name;
      },

      // 使用优惠券
      useCoupon() {
        console.log('使用优惠券');
        // 关闭对话框
        this.isShowChooseCoupon = false;
        // 用选中的优惠券ID重新调用房间查询接口
        this.loadData();
      },

      // 展示选择优惠券对话框
      showChooseCoupon() {
        if (this.isLogin) {
          // 页面跳转之前，先保存客人等关键数据，防止选完优惠券回来再重填
          const bookInfo = {
            firstName: this.firstName,
            lastName: this.lastName,
            guestNum: this.guestNum,
            regionName: this.regionName,
            regionCodeValue: this.regionCodeValue,
            phone: this.phone,
          };
          localStorage.setItem('bookInfo', JSON.stringify(bookInfo));

          // 跳转到优惠券选择页面
          gotoPage({
            path: '/ChooseCoupon',
            params: {roomType: this.roomData.room_type},
          });
        } else {
          this.isShowLoginModal = true;
        }

      },

      // 展示注册输入密码
      showRegister() {
        this.isShowPassword = true;
        this.gotoAnchor('#password');
        this.$refs.password.focus();
      },

      // 允许已有积分的未注册账号匿名下单
      anonymousOrder() {
        this.allowAnonymousOrder = true;
      },

      // 展示登录对话框
      showLoginModal() {
        this.isShowLoginModal = true;
      },

      // 获取用户邮箱
      getEmail() {
        if (this.isLogin) {
          return this.userInfo.email;
        } else {
          return '';
        }
      },

      // 从LoginModal子组件传来的状态值进行修改
      setIsShowLoginModal(val) {
        this.isShowLoginModal = val;
      },

      // 获取国家地区数据
      getRegionData() {
        this.regionData = getRegions();
      },

      // 获取国家地区电话编码数据
      getRegionCodes() {
        this.regionCodes = getRegionCodes();
      },

      // 国家地区选择变化时触发
      changeRegionIndex(value) {
        console.log('changeRegionIndex: ', value, this.regionData.indexOf(value));
        this.regionIndex = this.regionData.indexOf(value);
        this.regionCodeIndex = this.regionData.indexOf(value);
        this.regionCodeValue = this.regionCodes[this.regionCodeIndex].label;
      },

      // 国家地区编码变化时触发
      changeRegionCodeIndex(value) {
        console.log('地区编码： ', value);
        this.regionCodeValue = value;
      },

      // 计算免费退房日期
      getFreeCheckoutDate() {
        let checkinDate = moment(this.checkinDate + ' 14:00:00');
        this.freeCheckoutDate = checkinDate.subtract(1, 'd');
        console.log('freeCheckoutDate: ', this.freeCheckoutDate.format('YYYY-MM-DD HH:mm:ss'));
      },

      // 更新入住人数
      changeNum(num) {
        console.log('num: ', num)
        this.guestNum = num;
        // 调用房间查询接口更新数据
        this.loadData();
      },

      // 房间数据查询
      loadData() {
        // 判断是否登录，如果登录就用登录的查房接口，未登录就用未登录的查房接口
        let getRoomListAPI = '';
        if (this.isLogin) {
          getRoomListAPI = this.api.getRoomList;
        } else {
          getRoomListAPI = this.api.getRoomListNoLogin;
        }
        urlRequest({
          url: getRoomListAPI,
          method: 'POST',
          data: {
            'check_in_time': localStorage.getItem('checkinDate'),
            'departure_time': localStorage.getItem('checkoutDate'),
            'currency_type': getLocalCurrency(),
            'id': this.roomId,
            'mc_id': this.couponId,
            'number1': this.guestNum,
          }
        }).then(res => {
          this.roomData = res.data.msg[0];
          // 初始化最大入住人数
          this.maxNum = this.roomData.max;
        })
      },

      // 滚动到锚点
      gotoAnchor(anchor) {
        this.$el.querySelector(anchor).scrollIntoView({
          block: 'center',
          behavior: "smooth",
        });
      },

      //  保存常住人
      saveGuest() {
        urlRequest({
          url: this.api.addGuest,
          method: 'POST',
          data: {
            'surname': this.lastName,
            'name': this.firstName,
          }
        });
      },

      // 提交订单
      submitOrder() {
        console.log('提交订单参数： ', this.firstName, this.lastName, this.guestNum, this.email,
          this.password, this.confirmPassword, this.phoneWithRegionCode);
        console.log('国家地区： ', getMultiLangRegion(this.regionIndex, 'en'),
          getMultiLangRegion(this.regionIndex, 'cn'));

        // 输入校验
        if (empty(this.firstName)) {
          this.firstNameValidate = this.$t('message.bookRoom.notNoneValidate');
          this.gotoAnchor('#firstName');
          return;
        } else if (!isEnglishNameValidate(this.firstName)) {
          this.firstNameValidate = this.$t('message.bookRoom.englishNameValidate');
          this.gotoAnchor('#firstName');
          return;
        } else {
          this.firstNameValidate = '';
        }
        if (empty(this.lastName)) {
          this.lastNameValidate = this.$t('message.bookRoom.notNoneValidate');
          this.gotoAnchor('#lastName');
          return;
        } else if (!isEnglishNameValidate(this.lastName)) {
          this.lastNameValidate = this.$t('message.bookRoom.englishNameValidate');
          this.gotoAnchor('#lastName');
          return;
        } else {
          this.lastNameValidate = '';
        }
        if (empty(this.email)) {
          this.emailValidate = this.$t('message.bookRoom.notNoneValidate');
          this.gotoAnchor('#email');
          return;
        } else if (!emailValidate(this.email)) {
          this.emailValidate = this.$t('message.bookRoom.emailValidate');
          this.gotoAnchor('#email');
          return;
        }
        else {
          this.emailValidate = '';
        }
        if (empty(this.regionName)) {
          this.regionValidate = this.$t('message.bookRoom.notNoneValidate');
          this.gotoAnchor('#regionName');
          return;
        } else {
          this.regionValidate = '';
        }
        if (empty(this.phone)) {
          this.phoneValidate = this.$t('message.bookRoom.notNoneValidate');
          this.gotoAnchor('#phone');
          return;
        } else {
          this.phoneValidate = '';
        }

        // 如果勾选注册，则校验密码
        if (this.isShowPassword) {
          if (empty(this.password)) {
            this.passwordValidate = this.$t('message.bookRoom.notNoneValidate');
            this.gotoAnchor('#password');
            return;
          } else if (this.password.length < 6) {
            this.passwordValidate = this.$t('message.bookRoom.passwordLengthValidate');
            this.gotoAnchor('#password');
            return;
          } else {
            this.passwordValidate = '';
          }
          if (empty(this.confirmPassword)) {
            this.confirmPasswordValidate = this.$t('message.bookRoom.notNoneValidate');
            this.gotoAnchor('#confirm_password');
            return;
          } else if (this.password !== this.confirmPassword) {
            this.confirmPasswordValidate = this.$t('message.bookRoom.confirmPasswordValidate');
            this.gotoAnchor('#confirm_password');
            return;
          } else {
            this.confirmPasswordValidate = '';
          }
        }

        console.log('调用下订单接口！！！');
        // 如果勾选注册，则先调用注册接口，注册成功后再下订单
        if (this.isShowPassword) {
          // 注册下单
          urlRequest({
            url: this.api.register,
            method: 'POST',
            data: {
              'email': this.email,
              'member_pw': this.password,
              'confirm_password': this.confirmPassword,
              'cname': '',
            },
            handler: () => {
              console.log('已经注册过了，去登录下单。。。');
              // 弹出登录框
              this.isShowLoginModal = true;
              // 去掉注册勾选
              this.isShowPassword = false;
            }
          }).then(res => {
            // 注册成功，将相关信息写入缓存并更新状态
            let {token, user} = res.data.msg;
            localStorage.setItem('token', token);
            localStorage.setItem('userInfo', JSON.stringify(user));
            // 修改登录状态
            this.setLoginStatus(true);
            // 保存用户信息
            this.setUserInfo(user);
            // 保存常住人
            this.saveGuest();
            // 注册成功后，再下单
            urlRequest({
              url: this.api.bookRoom,
              method: 'POST',
              data: {
                'check_in_time': this.checkinDate,
                'departure_time': this.checkoutDate,
                'room_id': this.roomId,
                'phone': this.phoneWithRegionCode,
                'surname': this.lastName,
                'name': this.firstName,
                'nationality': getMultiLangRegion(this.regionIndex, 'cn'),
                'nationality_en': getMultiLangRegion(this.regionIndex, 'en'),
                'currency_type': getLocalCurrency(),
                'number1': this.guestNum,
                'mc_id': this.couponId,
              }
            }).then(res => {
              // 成功后跳转到订单详情页面
              gotoPage({
                path: '/OrderDetail',
                params: {orderId: res.data.msg.id}
              });
            });
          });
        } else if (!this.isLogin) {
          // 调用查询注册接口
          urlRequest({
            url: this.api.isRegistered,
            method: 'POST',
            data: {
              'email': this.email,
            }
          }).then(res => {
            if (res.data.msg.is === 1) {
              // 如果该邮箱已注册，弹出登录对话框去登录
              console.log('该邮箱已注册，去登录下单。。。');
              this.isShowLoginModal = true;
            } else if (!this.allowAnonymousOrder && res.data.msg.integral > 0) {
              // 如果邮箱没注册，但是已经订过房，则弹出注册提示
              console.log('该邮箱没注册，但以前下过单，希望去注册。。。');
              this.unRegisteredIntegral = res.data.msg.integral;
              this.isShowHopeRegister = true;
            } else {
              // 匿名下单
              urlRequest({
                url: this.api.bookRoomNoLogin,
                method: 'POST',
                data: {
                  'check_in_time': this.checkinDate,
                  'departure_time': this.checkoutDate,
                  'room_id': this.roomId,
                  'phone': this.phoneWithRegionCode,
                  'surname': this.lastName,
                  'name': this.firstName,
                  'nationality': getMultiLangRegion(this.regionIndex, 'cn'),
                  'nationality_en': getMultiLangRegion(this.regionIndex, 'en'),
                  'email': this.email,
                  'currency_type': getLocalCurrency(),
                  'number1': this.guestNum,
                }
              }).then(res => {
                // 成功后将订单数据保存在缓存，然后跳转
                localStorage.setItem('order', JSON.stringify(res.data.msg[0]));
                gotoPage({
                  path: '/OrderDetail'
                });
              });
            }
          });

        } else {
          // 保存常住人
          this.saveGuest();
          // 登录后下单
          urlRequest({
            url: this.api.bookRoom,
            method: 'POST',
            data: {
              'check_in_time': this.checkinDate,
              'departure_time': this.checkoutDate,
              'room_id': this.roomId,
              'phone': this.phoneWithRegionCode,
              'surname': this.lastName,
              'name': this.firstName,
              'nationality': getMultiLangRegion(this.regionIndex, 'cn'),
              'nationality_en': getMultiLangRegion(this.regionIndex, 'en'),
              'currency_type': getLocalCurrency(),
              'number1': this.guestNum,
              'mc_id': this.couponId,
            }
          }).then(res => {
            let orderId = res.data.msg.id;
            // 成功后跳转到订单详情页面
            gotoPage({
              path: '/OrderDetail',
              params: {orderId: orderId}
            });
          });
        }
      },

    },

    computed: {

      ...mapState([
        // 是否登录
        'isLogin',
        // 用户信息
        'userInfo',
      ]),

      // 客人数本地化
      guestNumStr() {
        let lang = getLocalLang();
        if (lang === 'en') {
          if (this.guestNum > 1) {
            return this.guestNum + ' adults';
          } else {
            return this.guestNum + ' adult';
          }
        } else {
          return this.guestNum + ' 位成人';
        }
      },

      // 入住晚数计算
      totalNights() {
        let checkinDateObj = moment(this.checkinDate);
        let checkoutDateObj = moment(this.checkoutDate);
        let lang = getLocalLang();
        let nights = checkoutDateObj.diff(checkinDateObj, 'days');
        if (lang === 'en') {
          if (nights > 1) {
            return nights + ' nights';
          } else {
            return nights + ' night';
          }
        } else {
          return nights + '晚';
        }

      },

      // 是否可免费退房
      isFreeRefundable() {
        return this.freeCheckoutDate.isAfter(moment());
      },

      // 免费退房时间本地化文字
      freeRefundableStr() {
        let lang = getLocalLang();
        if (lang === 'en') {
          return this.freeCheckoutDate.format('HH:mm') + ' on '
            + this.freeCheckoutDate.format('DD MMM YYYY');
        } else {
          return this.freeCheckoutDate.format('YYYY-MM-DD HH:mm');
        }
      },

      // 手机号码加上地区编码
      phoneWithRegionCode() {
        return this.regionCodeValue + ' ' + this.phone;
      },


    },

    components: {
      Coupon,
      LoginModal,
      mIcons,
    }
  }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/mainStyle.scss";
    @import "BookRoom.scss";
</style>
<style>
    .ivu-input {
        font-weight: bold;
    }

    .ivu-input-number-input {
        font-size: 1.6rem;
        font-weight: bold;
        margin-left: 10px;
    }
</style>
